api = require('./0_def.coffee')

api.factory 'api/OutstandingTasks#factory', [
  'ksc.RestList',
  (RestList) ->
    contract =
      taskId: { type: 'number' }
      priority: { type: 'number' }
      state: { type: 'string' }
      type: { type: 'string' }


    ->
      new RestList
        cache: true
        endpoint:
          url: '/dashboard-calendar-ui/api/OutstandingTasks'
        record:
          contract: contract
          idProperty: 'taskId'
          url: '/dashboard-calendar-ui/api/OutstandingTasks/<id>'
]

api.service 'api/OutstandingTasks', [
  'api/OutstandingTasks#factory',
  (outstandingTasksFactory) ->
    service = outstandingTasksFactory()

    # entire response can be cached, no partial loads. Load right away.
    service.restLoad()

    service
]
